import { Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {MiscelaneaService} from '../../../../../shared/services/miscelanea.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../core/service/auth.service';

import * as _ from 'underscore';
import Swal from 'sweetalert2';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';
import {StatsConfigService} from '../../services/stats-config.service';

@Component({
  selector: 'app-stats-config',
  templateUrl: './stats-config.component.html',
  styleUrls: ['./stats-config.component.scss']
})
export class StatsConfigComponent implements OnInit{

    form: FormGroup;
    configs: Array<Object> = [];
    enabled: boolean = false;
    errors: Object = {};
    submitted: boolean = false;

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 5;

    editData: Object = {'pk' : '', 'is_edit' : false};

    @ViewChild(PaginationComponent) pagination: PaginationComponent;


    constructor(private statsHandler: StatsConfigService, private misc: MiscelaneaService, private auth: AuthService) {
        this.form = new FormGroup(
            {
                lang: new FormControl('', Validators.required),
                provider: new FormControl('', Validators.required),
                name: new FormControl('', Validators.required),
                is_default: new FormControl('0'),
                fields: new FormControl('', Validators.required)
            }
        );
    }

    requestAutocompleteItems = (text: string): Observable<Response> => {
        return this.misc.findPhonePossibleResponses(
            {
                portal : this.auth.getPortalSelected().portal,
                lang: this.form.value.lang,
                provider: this.form.value.provider
            }, text
        );
    };

    editConfig(config: Object): void {

        this.editData['pk'] = config['pk'];
        this.editData['is_edit'] = true;

        var configData = this.statsHandler.toFormData(config);

        this.form.reset();
        this.form.setValue(configData);
    }

    updateStatConfig(): void {
        this.enabled = true;
        var updateData = this.statsHandler.toSendData(Object.assign({}, this.form.value), this.auth.getPortalSelected().portal);

        this.statsHandler.updateStatsConfig(this.editData['pk'], updateData).subscribe(
            (result) => {
                this.form.reset();
                this.editData['pk'] = '';
                this.editData['is_edit'] = false;
                this.init();
            }
        )
    }

    cloneConfig(config: Object): void {

        var configData = this.statsHandler.toFormData(config);
        this.form.reset();
        this.form.setValue(configData);
    }

    deleteConfig(config: Object): void {
        this.enabled = true;
        this.statsHandler.deleteStatsConfig(config['pk']).subscribe(
            (result) => {
                let idx = _.findIndex(this.configs, (obj) => { obj.pk === config['pk'] });
                this.configs.splice(idx, 1);
                this.enabled = false;
                Swal({type: 'success', title: 'Action performed', text: 'Config deleted successfully'});
            }
        )
    }

    createStatConfig(): void {

        this.errors = {};
        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        var postData = this.statsHandler.toSendData(Object.assign({}, this.form.value), this.auth.getPortalSelected().portal);

        this.statsHandler.createStatsConfig(postData).subscribe(
            (result) => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result.errors;
                }
                else{
                    this.errors = {};
                    this.form.value['name'] = '';
                    this.configs.push(result.data);
                    this.form.reset();
                    this.pagination.onPage(this.pagination.totalPages());
                }

                this.enabled = false;
            }
        )

    }

    goToPage(n: number) {
        this.startAt = this.pagination.getStart();
        this.endAt = this.pagination.getEnd();
    }

    ngOnInit() {
        this.init();
    }

    haveToPaginate(): boolean {
        return this.perPage < this.configs.length;
    }


    protected init(): void {
        this.enabled = true;
        this.statsHandler.getStatsConfigs().subscribe(
            (result) => {
                this.configs = result;
                this.endAt = (!this.haveToPaginate()) ? this.configs.length : this.perPage;
                this.enabled = false;
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/components/stats-config/stats-config.component.ts